import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerProClub.scss';
import '../assets/css/partnerPortal/welcome.scss';
import '../assets/css/partnerPortal/homepage.scss';

import arrowDown from '../assets/img/partnerPortal/EnablementSales/arrow-down.png'; 
import arrowWhite from '../assets/img/partnerPortal/homepage/arrowWhite.png'; 


function BannerOne(props) {

    const [bannerImage] = useState(props.bannerImage);
    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);
    const [firstButtonName] = useState(props.buttonName);
    const [firstButtonLink] = useState(props.buttonLink);
    const [secondButtonName] = useState(props.secondButtonName);
    const [secondButtonLink] = useState(props.secondButtonLink);
    const [hasNoButton] = useState(props.hasNoButton);
    const [logo] = useState(props.logo);
    const [logo2] = useState(props.logo2);
    const [aboveTitle] = useState(props.aboveTitle);
    const [logoWidth] = useState(props.logoWidth);
    const [mainClass] = useState(props.mainClass);
    const [isArrowDown] = useState(props.isArrowDown);
    const [buttonOneWidth] = useState(props.buttonOneWidth);
    const [lastButtonName] = useState(props.lastButtonName);
    const [lastButtonLink] = useState(props.lastButtonLink);
    const [marginTop] = useState(props.marginTop);
    const [targetFirstButton] = useState(props.targetFirstButton);
    const[secondButtonTarget] =useState(props.secondButtonTarget);

    function getButtons() {

        if (secondButtonName) {
            return <div>
                <div className="buttonDivTwo">
                        <a href={firstButtonLink} target="_parent" className={"d-flex justify-content-center mr-5 "}  >
                            <div className="buttonPrimary">
                                <div className="buttonPrimarySecond buttonLetters">{firstButtonName}</div>
                            </div>
                        </a>
                        {lastButtonName ?
                            <a href={secondButtonLink} target="_parent" className={"d-flex justify-content-center mr-5 "}  >
                                <div className="buttonPrimary">
                                    <div className="buttonPrimarySecond buttonLetters">{secondButtonName}</div>
                                </div>
                            </a> :
                            <a href={secondButtonLink} target={secondButtonTarget ? secondButtonTarget : ""} >
                                <div className="buttonSecondary">
                                    <div className={"buttonSecondarySecond buttonLetters "}>
                                        <div className="textAndUnderline">
                                            <div className="frame6 buttonLettersWhite">  {secondButtonName}
                                            </div>
                                            <div className="lineBlack2"></div>
                                        </div>
                                    
                                        {isArrowDown ? <img src={arrowDown}  alt='...' width={"15%"}  /> : <img src={arrowWhite}  alt='...' width={"10%"}  /> }

                                        
                                    </div>
                                    
                                </div>
                            </a>  
                            }             
                </div>
                {lastButtonName ? <a href={lastButtonLink} target="_parent" className={"d-flex align-items-center justify-content-center mr-5 mt-3"}  >
                    <div className="d-flex flex-column align-items-start justify-content-center width70">
                        <div className="buttonPrimarySecond buttonLetters">{lastButtonName}</div>
                    </div>
                </a> : ""}
            </div>
        }
        if (hasNoButton) {
            return null;
        }
        return      <div className="buttonDiv mt-4">
                        <a href={firstButtonLink} target={targetFirstButton ? targetFirstButton : "_blank"} className={"d-flex justify-content-center " + (buttonOneWidth ? buttonOneWidth : "wid20") } >
                            <div className="buttonWithoutBorder buttonSignUp pad7">
                                <div className="buttonLetters">{firstButtonName}</div>
                            </div>
                        </a>
                    </div>;
    }

    function addLogo() {
        if (logo) {
            return <div className="proClubDivLogo ml-5 mt-5" ><img src={logo} alt="proClubLogo" className="img-logo" /></div>
        }
    }

    function addLogo2() {
        if (logo2) {
            return <div>
                <div className="mb-4">
                    <img src={logo2} alt="logo" width={logoWidth} className="companyLogo" />
                </div>
                <div className="aboveTitle">
                    {aboveTitle}
                </div>
            </div>;
        }
    }


    return (

        <div className={"row d-flex " + mainClass}>
            <img src={bannerImage} className=' shadow-4 imageBanner ' alt='...' />
            {addLogo()}
            <div className={"boxBanner " + (marginTop ? marginTop : "addMarginTop8")}>
                {addLogo2()}
                <div className="boxHeaderText">
                    {title}
                </div>
                <div className="boxHeaderSubText">
                    {subTitle}
                </div>
                {getButtons()}
            </div>
            
        </div>

    )


}

export default withRouter(BannerOne);



